import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';
import CopyBox from '../components/bbcode/copybox';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { ButtonGroup } from 'react-bootstrap';

//import './css/index.css';
//import './css/header.css';

class PortalAdminDiscord extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				status: false,
				id: this.props.service,
				name: '',
			},
			discord: {
				active: false,
				guild: [],
				guilds: [],
				bot: '',
				api: '',
			},
			schedule: {
				current: '',
				change: '',
			},
			flyer: {
				current: '',
				change: '',
			},
			djrole: {
				current: '',
				change: '',
			}
			//names: [],
			//embeds: [],
		};
		this.getDiscord = this.getDiscord.bind(this);
		this.authorise = this.authorise.bind(this);
		this.authoriseGuild = this.authoriseGuild.bind(this);
		this.changeSchedule = this.changeSchedule.bind(this);
		this.changeFlyer = this.changeFlyer.bind(this);
		this.changeDJRole = this.changeDJRole.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		const y = await value.setWorker( this.props.service );
		//let server = value.worker[this.props.service] || y[this.props.service];
		EventEmitter.emit('/client', {data: 'no value'});

		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${this.context.worker[this.props.service]}/v3/admin/embeds`, params);

		//this.setState({names: x.data.names, embeds: x.data.embeds});

		let params2 = new URLSearchParams();
		params2.append('service', this.state.service.id);
		const z = await postApi(`/v3/portal/discord/bot`, params2);
		console.log(z.data);

		if( this.state.service.status === false ) {
			let service = this.state.service;
			service.status = true;
			service.name = x.data.servicename;
			//x.data.overview.shorttitle = x.data.description.title;
			let discord = this.state.discord;
			discord.active = z.data.active;
			discord.guild = z.data.guild;
			discord.guilds = z.data.guilds;
			discord.bot = z.data.bot;
			discord.api = z.data.api;
			this.setState({service, discord});
			setTitle('Discord', x.data.servicename);
			if( discord.guild?.schedule ) {
				let schedule = this.state.schedule;
				schedule.current = schedule.change = discord.guild.schedule;
				this.setState({schedule});
			}
			if( discord.guild?.flyer ) {
				let flyer = this.state.flyer;
				flyer.current = flyer.change = discord.guild.flyer;
				this.setState({flyer});
			}
			if( discord.guild?.djrole ) {
				let djrole = this.state.djrole;
				djrole.current = djrole.change = discord.guild.djrole;
				this.setState({djrole});
			}
		};

		//let params = new URLSearchParams();
		//const x = await postApi(`${server}/v3/admin/organiser`, params);
		//this.setState({status: true, services: x.data.Services});

		/*
		let params = new URLSearchParams();
		const x = await postApi('/v3/index', params);
		//this.setState({clubbers: x.data.Clubbers, radio: x.data.Radio, next: x.data.Next, posters: x.data.WeeklyDJs, sets: x.data.Sets, status: true, affliiate: x.data.Affiliate});

		const IndexSchedule = EventEmitter.addListener('/index/schedule', async data => {
			this.setState({next: data.Next, live: data.Live});
		}); this.setState({IndexSchedule});
		*/

	}

	componentWillUnmount() {
	}


	async getDiscord() {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const z = await postApi(`/v3/portal/discord/bot`, params);
		consoleLog(z.data);

		let discord = this.state.discord;
		discord.active = z.data.active;
		discord.guild = z.data.guild;
		discord.guilds = z.data.guilds;
		discord.bot = z.data.bot;
		discord.api = z.data.api;
		
		this.setState({discord: {active: false, guild: [], guilds: [], bot: '', api: ''}},()=>{
			this.setState({discord});
		});

	}


	async authorise() {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('id', 0);
		params.append('platform', 'discord');
		let x = await postApi(`/v3/portal/platforms`, params);
		consoleLog(x.data);
	}


	async authoriseGuild(id) {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('id', id);
		const x = await postApi(`/v3/portal/discord/api`, params);
		consoleLog(x.data);
		if( x.status === 200 ) {

			/*
			const z = await postApi(`/v3/portal/discord/bot`, params2);
			
			let discord = this.state.discord;
			discord.active = z.data.active;
			discord.guild = z.data.guild;
			discord.guilds = z.data.guilds;
			discord.bot = z.data.bot;
			discord.api = z.data.api;
			
			this.setState({discord: []});
			*/

		}
	}

	async changeSchedule(item, save = false, cancel = false) {
		let schedule = this.state.schedule;
		if( cancel ) {
			schedule.current = this.state.discord.guild.schedule;
			schedule.change = this.state.discord.guild.schedule;
			this.setState({schedule});
			return;
		}
		if( save ) {
			schedule.current = schedule.change;
			this.setState({schedule});
			let params = new URLSearchParams();
			params.append('service', this.state.service.id);
			params.append('schedule', schedule.change);
			const x = await postApi(`/v3/portal/discord/api`, params);
			
			await this.getDiscord();
			return;
		}
		schedule.current = this.state.discord.guild.schedule;
		schedule.change = item.target.value;
		this.setState({schedule})
	}

	async changeFlyer(item, save = false, cancel = false) {
		let flyer = this.state.flyer;
		if( cancel ) {
			flyer.current = this.state.discord.guild.flyer;
			flyer.change = this.state.discord.guild.flyer;
			this.setState({flyer});
			return;
		}
		if( save ) {
			flyer.current = flyer.change;
			this.setState({flyer});
			let params = new URLSearchParams();
			params.append('service', this.state.service.id);
			params.append('flyer', flyer.change);
			const x = await postApi(`/v3/portal/discord/api`, params);
			
			await this.getDiscord();
			return;
		}
		flyer.current = this.state.discord.guild.flyer;
		flyer.change = item.target.value;
		this.setState({flyer})
	}


	async changeDJRole(item, save = false, cancel = false) {
		let djrole = this.state.djrole;
		if( cancel ) {
			djrole.current = this.state.discord.guild.djrole;
			djrole.change = this.state.discord.guild.djrole;
			this.setState({djrole});
			return;
		}
		if( save ) {
			djrole.current = djrole.change;
			this.setState({djrole});
			let params = new URLSearchParams();
			params.append('service', this.state.service.id);
			params.append('djrole', djrole.change);
			const x = await postApi(`/v3/portal/discord/api`, params);
			
			await this.getDiscord();
			return;
		}
		djrole.current = this.state.discord.guild.djrole;
		djrole.change = item.target.value;
		this.setState({djrole})
	}
	

	render() {
		const user = this.context;

		const guilds = this.state.discord.guilds.map((e,i) => {
			return (
				<Row key={i}>
					<div style={{width:90}}>
						<img src='' style={{width: 90, height: 90, border: '1px solid #555555', borderRadius: '50%'}} />
					</div>
					<Col>
						{e.name}<br />
						<Button size="sm" onClick={()=>this.authoriseGuild(e.id)}>Authorise</Button>
					</Col>
				</Row>
			)
		});


		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Discord</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
							<Row>
									
								<Col lg={12}>
                  <div className="card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">Discord</span>
													<p className="fs-13 text-muted mb-0">Extend the schedule and stream info into Discord</p>
												</div>
                      </div>
                    </div>
										<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
										
                  </div>
                </Col>

								{this.state.discord.active === false ?
									<Col xs={12}>
										<div className="card custom-card custom-frame">
											<div className="card-header justify-content-between">
												<div className="card-title">
													Enable Discord
												</div>
											</div>
											<div className="card-body">
												<Row>
													<Col xs={12}>
														<p>
															Step 1 - Invite Ultrastream Bot to your server
														</p>
													</Col>
													<div style={{width:90}}>
														<img src='' style={{width: 90, height: 90, border: '1px solid #555555', borderRadius: '50%'}} />
													</div>
													<Col>
														<a href={this.state.discord.bot} target="_blank" rel="noreferrer"><Button size="sm">Invite</Button></a>
													</Col>
													<Col xs={12} className="p-2"></Col>
													{this.state.discord.guilds.length===0?
														<>
															<Col xs={12}>
																<p>
																	Step 2 - Access your Discord account to verify the Discord server.
																</p>
															</Col>
															<div style={{width:90}}>
																<img src='' style={{width: 90, height: 90, border: '1px solid #555555', borderRadius: '50%'}} />
															</div>
															<Col>
																<a href={this.state.discord.api} target="_blank" rel="noreferrer"><Button size="sm" onClick={()=>this.authorise()}>Authorise</Button></a>
															</Col>
														</>
													:
														<>
															<Col xs={12}>
																<p>
																	Step 3 - Select your Discord server:
																</p>
															</Col>
															{guilds}
														</>
													}
												</Row>
											</div>
										</div>
									</Col>
								:
									<>
										<Col lg={12}>
											<div className="card">
												<div className="card-header">
													<div className="card-title">
														DJ Schedule
													</div>
												</div>
												<div className="card-body">
													<p>
														Interact the current schedule into Discord
													</p>
													<Row>
														<Col sm={6}>
															Example
														</Col>
														<Col sm={6}>
															Select Channel<br />
															<select className="form-select" aria-label="Default select example" value={this.state.schedule.change} onChange={this.changeSchedule}>
																<option value="">Disabled - Open this select menu</option>
																{(() => {
																	return this.state.discord.guild.channels.map((e,i) => {
																		return (
																			<option key={i} value={e.id}>{e.name}</option>
																		)
																	})
																})()}
															</select>
															{this.state.schedule.current !== this.state.schedule.change &&
																<ButtonGroup>
																	<Button size="sm" onClick={()=>this.changeSchedule('', true, false)}>Save</Button>
																	<Button size="sm" onClick={()=>this.changeSchedule('', false, true)}>Cancel</Button>
																</ButtonGroup>
															}
														</Col>
													</Row>
												</div>
												
											</div>
										</Col>

										<Col lg={12}>
											<div className="card">
												<div className="card-header">
													<div className="card-title">
														Schedule Flyers
													</div>
												</div>
												<div className="card-body">
													<p>
														Post the flyers into Discord
													</p>
													<Row>
														<Col sm={6}>
															Example
														</Col>
														<Col sm={6}>
															Select Channel<br />
															<select className="form-select" aria-label="Default select example" value={this.state.flyer.change} onChange={this.changeFlyer}>
																<option value="">Disabled - Open this select menu</option>
																{(() => {
																	return this.state.discord.guild.channels.map((e,i) => {
																		return (
																			<option key={i} value={e.id}>{e.name}</option>
																		)
																	})
																})()}
															</select>
															{this.state.flyer.current !== this.state.flyer.change &&
																<ButtonGroup>
																	<Button size="sm" onClick={()=>this.changeFlyer('', true, false)}>Save</Button>
																	<Button size="sm" onClick={()=>this.changeFlyer('', false, true)}>Cancel</Button>
																</ButtonGroup>
															}
														</Col>
													</Row>
												</div>
												
											</div>
										</Col>

										<Col lg={12}>
											<div className="card">
												<div className="card-header">
													<div className="card-title">
														DJ Clients
													</div>
												</div>
												<div className="card-body">
													<p>
														Auto Assign the DJ rank onto members
													</p>
													<Row>
														<Col sm={6}>
															Example
														</Col>
														<Col sm={6}>
															Select Role<br />
															<select className="form-select" aria-label="Default select example" value={this.state.djrole.change} onChange={this.changeDJRole}>
																<option value="">Disabled - Open this select menu</option>
																{(() => {
																	return this.state.discord.guild.roles.map((e,i) => {
																		return (
																			<option key={i} value={e.id}>{e.name}</option>
																		)
																	})
																})()}
															</select>
															{this.state.djrole.current !== this.state.djrole.change &&
																<ButtonGroup>
																	<Button size="sm" onClick={()=>this.changeDJRole('', true, false)}>Save</Button>
																	<Button size="sm" onClick={()=>this.changeDJRole('', false, true)}>Cancel</Button>
																</ButtonGroup>
															}
														</Col>
													</Row>
												</div>
												
											</div>
										</Col>
									</>
								}
								
								
									
							</Row>
						</div>
					</div>
				}
			</>
		);
	}
}

const Discord = props => {
  const { service } = useParams();
  return <PortalAdminDiscord service={service} {...props} />
}
export default Discord;